import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    forgetRes: [],
    forgetVerifyRes: [],
    resetPasswordRes: [],
    changePasswordRes: [],
    error: "",
}

const forgetSlice = createSlice({
    name: 'forget',
    initialState,
    reducers: {
        forgetpassword: (state, action) => {
            state.forgetRes = action.payload
        },
        verifyCode: (state, action) => {
            state.forgetVerifyRes = action.payload
        },
        reset: (state, action) => {
            state.resetPasswordRes = action.payload
        },
        changepassword: (state, action) => {
            state.changePasswordRes = action.payload
        },
    }
})

export const { forgetpassword, verifyCode, reset, changepassword } = forgetSlice.actions;
export default forgetSlice.reducer;

export const forgetPassword = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.userforgotpassword}`, data);
            callback(response)
            dispatch(forgetpassword(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };


export const verifyMail = (id, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.forgotusercheck}/${id}`);
            callback(response)
            dispatch(verifyCode(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const resetPassword = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.usersresetpassword}`, data);
            callback(response)
            dispatch(reset(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const changePassword = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.changepassworduser}`, data);
            callback(response)
            dispatch(changepassword(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

